@if (!this.data?.orderPcc && !this.data?.completeIncorporation) {
  <div class="content">
    <div class="image-container">
      <img src="assets/images/complete-profile.png" class="image" />
    </div>
    <div  class="text-container" data-testid="dqf-complete-profile-message">
      Please complete the <span class="bold-text">Required Information</span> sections of your Profile to proceed with DQF
      for <span class="bold-text">{{ this.data?.carrierName | uppercase }}</span>
    </div>
    <div  class="btn-container">
      <button mat-raised-button color="primary" class="save-button" (click)="closeDialog()" data-testid="dqf-complete-profile-btn">
        Complete Profile
      </button>
    </div>
  </div>
}
@if (this.data?.orderPcc) {
  <div class="content">
    <div class="image-container">
      <img src="assets/images/complete-profile.png" class="image" />
    </div>
    <div  class="btn-container">
      <button mat-raised-button color="primary" class="save-button" (click)="closeDialog()" data-testid="dqf-order-pcc-complete-profile-btn">
        Complete Profile
      </button>
    </div>
  </div>
}
@if (this.data?.completeIncorporation) {
  <div class="content">
    <div class="image-container">
      <img src="assets/images/complete-profile.png" class="image" />
    </div>
    <div class="text-container" data-testid="dqf-complete-incorporation-message">
      Please complete the <span class="bold-text">Incorporation / WSIB</span> section of your profile to proceed with signing declaration
    </div>
    <div class="btn-container">
      <button mat-raised-button color="primary" class="save-button" (click)="closeDialog()" data-testid="dqf-complete-incorporation-btn">
        Complete Incorporation
      </button>
    </div>
  </div>
}